// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  index(context, params) {
    const { sortBy, descending, page, rowsPerPage } = params.pagination
      ? params.pagination
      : [null, null, null, null];
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("currencies", {
        page: page,
        sortBy: sortBy,
        descending: descending,
        rowsPerPage: rowsPerPage,
        search: params.search,
        locationId: params.locationId
      })
        .then(({ data }) => {
          context.commit("set_currencies", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  list(context) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("currencies")
        .then(({ data }) => {
          context.commit("set_currencies", data);
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  add(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.post("currencies", params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  },
  update(context, params) {
    context.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.put("currencies/" + params.model.id, params.model)
        .then(({ data }) => {
          context.commit("unset_loading");
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit("set_error", response.data.errors);
        });
    });
  }
};
